<template>
  <div class="md:tw-mx-16 tw-pb-48 md:tw-pb-24 md:tw-pt-4 lg:tw-pt-4">
    <div class="tw-text-left tw-mb-8 tw-mx-4 md:tw-mx-0">
      <RouterLink to="/menu" class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium"></RouterLink>
    </div>

    <div class="tw-flex">
      <div class="tw-flex-shrink-0 tw-w-156 tw-hidden xl:tw-block">
        <template v-if="viewLoading">
          <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white">
            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
          
            <div class="tw-px-8">
              <SkeletonLoader class="tw-w-1/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-2/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
            </div>
          </div>
        </template>

        <template v-else>
          <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white">
            <div class="tw-bg-black tw-py-4 tw-px-8 tw-text-white tw-flex tw-cursor-pointer" @click="sidePanelOpen = !sidePanelOpen" v-if="false">
              <h3 class="tw-text-2xl tw-font-black tw-uppercase">Menu</h3> <span :class="['tw-ml-auto fa fa-chevron-right tw-transition', {'tw-rotate-90': sidePanelOpen}]"></span>
            </div>
            <TwCollapse
              :duration="300"
              :collapseOpen="sidePanelOpen">
              <div class="tw-px-16 tw-py-12">
                <CategoryLink
                  class="tw-mb-4 tw-w-full tw-block"
                  v-for="category in getMenu"
                  :key="category.id"
                  :category="category"
                  />
                <div class="tw-mb-4 tw-w-full tw-block">
                  <router-link class="tw-cursor-pointer tw-group tw-w-full tw-block" :to="{ name: 'all-categories'}">
                    <div :class="['tw-uppercase']">
                      All Categories
                    </div>
                  </router-link>
                </div>
              </div>
            </TwCollapse>
          </div>
        </template>
      </div>

      <div class="tw-w-full tw-flex-1 lg:tw-mx-12">  
        <div class="tw-mx-8 md:tw-mx-0" 
          v-if="!viewLoading && userStore.userLocation && userStore.userLocation.id">
          <LocationAlerts :location="(userStore.userLocation! as any) as Location" />
        </div>

        <template v-if="viewLoading">
          <div class="tw--mx-1 lg:tw--mx-4 xl:tw--mx-1 2xl:tw--mx-4">
            <div class="tw-mb-8">
              <div class="tw-rounded-3xl tw-overflow-hidden tw-cursor-pointer tw-shadow-lg tw-bg-white tw-px-16 tw-py-16 xl:tw-mx-4">
                <SkeletonLoader class="tw-w-1/3 tw-h-16 tw-mb-8" />
                <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
                <SkeletonLoader class="tw-w-1/2 tw-h-8 tw-mb-4" />
              </div>
            </div>
            <template v-if="suggestedOrdersOpen">
              <div class="tw-flex tw-flex-wrap tw-pb-16 tw-pt-8 md:tw-px-1">
                <div 
                  class="tw-flex md:tw-my-1 md:tw-px-1 tw-w-full md:tw-w-1/2 md:tw-pb-8 xl:tw-pb-8 xl:tw-px-4 xl:tw-w-1/3 tw-border-b tw-border-gray-500 md:tw-border-b-0" 
                  v-for="idx in 3" 
                  :key="'loader-'+idx">
                  <div class="tw-overflow-hidden tw-rounded-3xl tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-block">
                    <div class="tw-overflow-hidden tw-block tw-h-auto tw-w-full">
                      <SkeletonLoader class="tw-w-full tw-h-96" />
                    </div>
                    <div class="tw-mx-12 tw-mt-8 tw-pb-8">
                      <SkeletonLoader class="tw-w-full tw-h-12" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="tw-mb-8">
              <div class="tw-rounded-3xl tw-overflow-hidden tw-cursor-pointer tw-shadow-lg tw-bg-white tw-px-16 tw-py-16 xl:tw-mx-4">
                <SkeletonLoader class="tw-w-1/3 tw-h-16 tw-mb-8" />
                <SkeletonLoader class="tw-w-1/4 tw-h-8 tw-mb-4" />
              </div>
            </div>
            <template v-if="menuOpen">
              <div class="tw-flex tw-flex-wrap">
                <div 
                  class="tw-flex md:tw-my-1 md:tw-px-1 tw-w-full md:tw-w-1/2 md:tw-pb-8 xl:tw-pb-8 xl:tw-px-4 xl:tw-w-1/3 tw-border-b tw-border-gray-500 md:tw-border-b-0" 
                  v-for="idx in 12" 
                  :key="'loader-'+idx">
                  <div class="tw-overflow-hidden tw-rounded-3xl tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-block">
                    <div class="tw-overflow-hidden tw-block tw-h-auto tw-w-full">
                      <SkeletonLoader class="tw-w-full tw-h-96" />
                    </div>
                    <div class="tw-mx-12 tw-mt-8 tw-pb-8">
                      <SkeletonLoader class="tw-w-full tw-h-12" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>

        <template v-else>
          <div class="tw--mx-1 lg:tw--mx-4 xl:tw--mx-1 2xl:tw--mx-4">
            <template v-if="cateringOrderStore.suggestions && cateringOrderStore.suggestions.length > 0">
              <div class="tw-mb-8">
                <div 
                  class="tw-rounded-3xl tw-overflow-hidden tw-cursor-pointer tw-shadow-lg tw-bg-white tw-px-16 tw-py-16 xl:tw-mx-4 hover:tw-text-orange-medium" 
                  @click="toggleSuggestionsCollapse">
                  <div class="tw-relative tw-pr-24">
                    <h2 class="tw-text-6xl tw-font-black tw-mr-auto tw-transition-all tw-duration-300">
                      Need Some Suggestions?
                    </h2>
                    <p class="tw-text-3xl tw-italic tw-pt-4 tw-mb-0 lg:tw-w-3/4 tw-transition-all tw-duration-300">These orders have been curated specifically for you and are a complete, one-click package to get you everything you need for your catering order.</p>
                    <span :class="['tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-right-0 fa fa-chevron-right tw-transition tw-inline-block tw-origin-center tw-text-3xl', {'tw-rotate-90': suggestedOrdersOpen}]"></span>
                  </div>
                </div>
                <TwCollapse
                  :duration="300"
                  :collapseOpen="suggestedOrdersOpen"
                  v-if="cateringOrderStore.suggestions && cateringOrderStore.suggestions.length > 0">
                  <div>
                    <div class="tw-flex tw-flex-wrap tw-pb-12 tw-pt-8 xl:tw-mx-4 2xl:tw-mx-0">
                      <SuggestedOrder
                        v-for="(suggestion, index) in cateringOrderStore.suggestions" 
                        class="tw-flex xl:tw-my-0 xl:tw-px-0 tw-w-full 2xl:tw-w-1/3 2xl:tw-mb-8 2xl:tw-px-4 tw-border-b tw-border-gray-500 2xl:tw-border-b-0"
                        :suggestion="suggestion"
                        :isLoading="addingSuggestion == index"
                        :isDisabled="addingSuggestion > -1"
                        :index="index" 
                        @handleSuggestedOrderClick="addSuggestionToBag"
                        @handleSuggestedOrderModal="popSuggestionModal"/>  
                    </div>
                  </div>
                </TwCollapse>
              </div>
            </template>

            <template v-else>
              <div class="tw-mb-8">
                <div 
                  class="tw-rounded-3xl tw-overflow-hidden tw-cursor-pointer tw-shadow-lg tw-bg-white tw-px-16 tw-py-16 xl:tw-mx-4 hover:tw-text-orange-medium" 
                  @click="toggleSuggestionsCollapse">
                  <div class="tw-relative tw-pr-24">
                    <h2 class="tw-text-6xl tw-font-black tw-mr-auto tw-transition-all tw-duration-300">
                      Need Some Suggestions?
                    </h2>
                    <p class="tw-text-3xl tw-italic tw-pt-4 tw-mb-0 lg:tw-w-3/4 tw-transition-all tw-duration-300">These orders have been curated specifically for you and are a complete, one-click package to get you everything you need for your catering order.</p>
                    <span :class="['tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-right-0 fa fa-chevron-right tw-transition tw-inline-block tw-origin-center tw-text-3xl', {'tw-rotate-90': suggestedOrdersOpen}]"></span>
                  </div>
                </div>
              </div>
              <template v-if="suggestedOrdersOpen">
                <div class="tw-flex tw-flex-wrap">
                  <div 
                    class="tw-flex md:tw-my-1 md:tw-px-1 tw-w-full md:tw-w-1/2 md:tw-pb-8 xl:tw-pb-8 xl:tw-px-4 xl:tw-w-1/3 tw-border-b tw-border-gray-500 md:tw-border-b-0" 
                    v-for="idx in 3" 
                    :key="'loader-'+idx">
                    <div class="tw-overflow-hidden tw-rounded-3xl tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-block">
                      <div class="tw-overflow-hidden tw-block tw-h-auto tw-w-full">
                        <SkeletonLoader class="tw-w-full tw-h-96" />
                      </div>
                      <div class="tw-mx-12 tw-mt-8 tw-pb-8">
                        <SkeletonLoader class="tw-w-full tw-h-12" />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>

            <div class="tw-mb-12">
              <div 
                class="tw-mb-8 tw-rounded-3xl tw-overflow-hidden tw-cursor-pointer tw-shadow-lg tw-bg-white tw-px-16 tw-py-16 xl:tw-mx-4 hover:tw-text-orange-medium" 
                @click="menuOpen = !menuOpen">
                <div class="tw-relative tw-pr-24">
                  <h2 class="tw-text-6xl tw-font-black tw-mr-auto tw-transition-all tw-duration-300">
                    Menu
                  </h2>
                  <div class="tw-italic tw-transition-all tw-duration-300 tw-pt-4 ">
                    {{ menuOpen ? 'Click to hide' : 'Click to expand'}}
                  </div>
                  <span :class="['tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-right-0 fa fa-chevron-right tw-transition tw-inline-block tw-origin-center tw-text-3xl', {'tw-rotate-90': menuOpen}]"></span>
                </div>
              </div>
              <TwCollapse
                :duration="500"
                :collapseOpen="menuOpen">
                  <div class="tw-flex tw-flex-wrap">
                    <Category
                      class="tw-flex md:tw-my-1 md:tw-px-1 tw-w-full md:tw-w-1/2 md:tw-pb-8 xl:tw-pb-8 xl:tw-px-4 xl:tw-w-1/3 tw-border-b tw-border-gray-500 md:tw-border-b-0"
                      v-for="category in getMenu"
                      :key="category.id"
                      :category="category"
                     />
                  </div>
              </TwCollapse>
            </div>
          </div>
        </template>
      </div>

      <div class="tw-flex-shrink-0 tw-w-156 tw-hidden lg:tw-block">
        <div class="tw-rounded-3xl tw-overflow-hidden tw-shadow-lg tw-bg-white tw-mb-16">
          <template v-if="viewLoading">
            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
          
            <div class="tw-px-8">
            <SkeletonLoader class="tw-w-1/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-2/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-3/4 tw-h-8 tw-mb-8" />
            </div>

            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
            <div class="tw-px-8">
            <SkeletonLoader class="tw-w-2/3 tw-h-8 tw-mb-8" />
              <SkeletonLoader class="tw-w-2/3 tw-h-8 tw-mb-8" />
            </div>

            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
            <div class="tw-px-8">
              <SkeletonLoader class="tw-w-1/3 tw-h-8 tw-mb-4" />
              <SkeletonLoader class="tw-w-full tw-h-4 tw-mb-8" />
            </div>
            
            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
            <div class="tw-px-8">
              <SkeletonLoader class="tw-w-full tw-h-24 tw-mb-8" />
              <SkeletonLoader class="tw-w-full tw-h-24 tw-mb-8" />
            </div>

            <SkeletonLoader class="tw-w-full tw-h-16 tw-block tw-mb-8" />
            <div class="tw-px-8">
              <SkeletonLoader class="tw-w-full tw-h-4 tw-mb-8" />
              <SkeletonLoader class="tw-w-full tw-h-4 tw-mb-8" />
              <SkeletonLoader class="tw-w-full tw-h-4 tw-mb-8" />
              <SkeletonLoader class="tw-w-full tw-h-4 tw-mb-8" />
            </div>
          </template>

          <template v-else>
            <OrderDetails />
            <Bag />
            <div class="tw-border-black tw-border-t tw-border-black tw-pt-8 tw-px-8" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
              <BagTotals />
            </div>
            <div class="tw-text-center tw-mt-16" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
              <router-link
                :to="{ name: 'review-bag'}"
                class="tw-block tw-w-full tw-bg-orange-medium tw-text-white hover:tw-bg-orange-dark hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200" 
                >
                Checkout
              </router-link>
            </div>
          </template>
        </div>

        <TwCateringHelp />
      </div>
    </div>


    <TwModal
      v-show="modalSuggestionOpen"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="closeSuggestionModal"
    >

      <template v-slot:body>
        <template v-if="suggestedOrderModalItem != null">
          <div class="tw-relative tw-pr-24 tw-w-full">
            <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">{{suggestedOrderModalItem.title}}</h2>
            <h2 class="tw-mx-8 tw-font-bold tw-text-4xl tw-block lg:tw-hidden tw-mb-4">${{ suggestedOrderModalItem.cost!.toLocaleString("en-US", {minimumFractionDigits: 2}) }}</h2>

             <button
                type="button"
                class="tw-text-5xl tw-absolute tw-right-2 tw-top-0 hover:tw-text-orange-medium tw-transition-all tw-duration-300"
                @click="closeSuggestionModal"
              >
                &times;
              </button>
          </div>

          <p class="tw-mx-8 tw-mb-8 tw-text-3xl !tw-leading-relaxed">
            {{suggestedOrderModalItem.description}}
          </p>
        </template>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8" v-if="suggestedOrderModalItem != null">
          <TwButton 
            cssClass="tw-border-2 tw-border-gray-400 tw-text-gray-400 hover:tw-bg-orange-medium hover:tw-border-orange-medium hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full"
            @emit-click="closeSuggestionModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Close'"/>

          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full tw-inline-block lg:tw-hidden"
            @emit-click="addSuggestionFromModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Add to Bag'"/>

          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full tw-hidden lg:tw-inline-block"
            @emit-click="addSuggestionFromModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="modalAddToBagText"/>
        </div>
      </template>
    </TwModal> 
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, onBeforeMount, onMounted, ref, nextTick
  } from 'vue';
  import { useRouter } from 'vue-router';

  // Data
  import { useBasketStore } from '../../stores/basket';
  import { useCateringOrderStore } from '../../stores/catering_order';
  import { useMenuStore } from '../../stores/menu';
  import { useUserStore } from '../../stores/user';
  import { useFlashMessageStore } from '../../stores/flashMessages';


  import type Basket from '../../classes/Basket';
  import type Location from '../../classes/Location';
  import type Product from '../../classes/Product';
  import type CateringOrderSuggestion from '../../classes/CateringOrderSuggestion';
  import type FlashMessage from '../../types/FlashMessage';
  import type OrderProduct from '../../types/OrderProduct';

  // Components
  import SkeletonLoader from '../../components/SkeletonLoader.vue';
  import Category from './_MenuCategory.vue';
  import SuggestedOrder from './_SuggestedOrder.vue';
  import OrderDetails from '../bag/_OrderDetails.vue';
  import Bag from '../bag/_Bag.vue';
  import BagTotals from '../bag/_BagTotals.vue';
  import CategoryLink from './_CategoryLink.vue';
  import TwCollapse from '../../components/TwCollapse.vue';
  import TwCateringHelp from '../../components/TwCateringHelp.vue';
  import LocationAlerts from '../../components/LocationAlerts.vue';
  import TwModal from '../../components/TwModal.vue';
  import TwButton from '../../components/TwButton.vue';

  const router = useRouter();

  const basketStore = useBasketStore();
  const cateringOrderStore = useCateringOrderStore();
  const menuStore = useMenuStore();
  const userStore = useUserStore();
  const flashMessageStore = useFlashMessageStore();

  const sidePanelOpen = ref(true);
  const suggestedOrders = ref([] as CateringOrderSuggestion[]);
  const addingSuggestion = ref(-1);
  const suggestedOrdersOpen = ref(false);
  const menuOpen = ref(true);

  const modalSuggestion = ref(-1);
  const modalSuggestionOpen = ref(false);

  const getMenu = computed(() => {
    return menuStore.getFilteredMenu;
  });

  const viewLoading = computed(() => {
    let basketLoaded = false;
    let menuLoaded = false;
    let imagesLoaded = true;

    if (localStorage.getItem('mypiadaBasketId')) {
      if (basketStore.basket && basketStore.basket.id) {
        basketLoaded = true;
      }
    } else {
      basketLoaded = true;
    }

    if (getMenu.value && getMenu.value.length > 0) {
      menuLoaded = true;
    }

    return (!basketLoaded || !menuLoaded || !imagesLoaded);
  })

  onBeforeMount(() => {
    if (cateringOrderStore.cateringOrder && typeof(cateringOrderStore.cateringOrder.assistance_level) != undefined) {
      let assistanceLvl = cateringOrderStore.cateringOrder.assistance_level;
      let suggestionsUserPreference = localStorage.getItem('suggestionsCollapseOpen');
      if (suggestionsUserPreference) {
        suggestedOrdersOpen.value = (suggestionsUserPreference == 'true');
      } else if (assistanceLvl >= 3) {
        suggestedOrdersOpen.value = true;
      }
      
      if (assistanceLvl >= 5) {
        menuOpen.value = false;
      }

      if (cateringOrderStore.suggestions == null || cateringOrderStore.suggestions.length == 0) {
        cateringOrderStore.fetchCateringOrderSuggestion();
      }
    }
  })

  onMounted(() => {
    if (userStore.userLocation != null && cateringOrderStore.cateringOrder) {
      menuStore.fetchMenu(parseFloat(userStore.userLocation.extref));

    } else {
      router.push('wizard'); // User doesn't have a location set so force them to pick one;
    }

  })

  const toggleSuggestionsCollapse = (() => {
    suggestedOrdersOpen.value = !suggestedOrdersOpen.value;
    localStorage.setItem('suggestionsCollapseOpen', suggestedOrdersOpen.value.toString());
  })

  // Will return a promise of the product add so that it can be handled in the async caller
  const addProduct = ((product: Product, trackSuggestion?: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      let opts = [] as number[];

      if (product.options && product.options.length > 0) {
        opts = product.options;
      } 

      basketStore.addProduct(product.id, product.quantity, "", opts, [], trackSuggestion).then(() => {
        resolve('');
      }).catch((error: Error) => {
        reject(error);
      })
    })
  })

  // Send off multiple add product calls using await so that the basket can't get out of sync
  const addSuggestionToBag = (idx: number) => {

    return new Promise((resolve, reject) => {
      addingSuggestion.value = idx;
      let errors = [] as Error[];

      if (cateringOrderStore.suggestions && cateringOrderStore.suggestions![idx] && cateringOrderStore.suggestions![idx].products) {
        let orderProducts = [] as OrderProduct[];
        for (const product of cateringOrderStore.suggestions![idx].products!) {

          let prod: OrderProduct = {
            id: product.id,
            productid: product.id,
            quantity: product.quantity,
            specialInstructions: '',
            options: product.options,
          };

          orderProducts.push(prod);
        }

        basketStore.addMultipleProducts(orderProducts, cateringOrderStore.suggestions![idx].id).then((basket: Basket) => {
          addingSuggestion.value = -1; 

          if (basket.message && basket.message.length > 0) {
            const message = {
              id: Math.round(Math.random() * 10000000),
              messageType: "danger",
              text: basket.message,
              headline: '',
              delay: 0, // ms
              icon: "",
              cssClass: "",
            } as FlashMessage;
            flashMessageStore.addMessage(message);
          } else {
            const message = {
              id: Math.round(Math.random() * 10000000),
              messageType: "success",
              text: "Products have been added to bag",
              headline: "",
              delay: 5000, // ms
              icon: "",
              cssClass: "",
            } as FlashMessage;
            flashMessageStore.addMessage(message);
          }

          resolve('');
        }).catch((error: Error) => {
          addingSuggestion.value = -1; 
          reject(error);
        })
      }
    });
  }

  const popSuggestionModal = (idx: number) => {

    if (cateringOrderStore.suggestions && cateringOrderStore.suggestions![idx]) {
      modalSuggestion.value = idx;
      modalSuggestionOpen.value = true;
    }
  }

  const addSuggestionFromModal = (() => {
     addSuggestionToBag(modalSuggestion.value);
     closeSuggestionModal();
  })

  const closeSuggestionModal = (() => {
    modalSuggestionOpen.value = false;
    window.setTimeout(function() {
      // Give the modal time to close before erasing the values
      modalSuggestion.value = -1;
    }, 500);
  })

  const suggestedOrderModalItem = computed(() => { 
    if (modalSuggestion.value > -1 && cateringOrderStore.suggestions && cateringOrderStore.suggestions![modalSuggestion.value]) {
      return (cateringOrderStore.suggestions![modalSuggestion.value]);
    } else {
      return null;
    }
  })

  const modalAddToBagText = computed(() => {
    let str = 'Add to Bag - $';
    if (suggestedOrderModalItem.value) {
      str += suggestedOrderModalItem.value.cost!.toLocaleString("en-US", {minimumFractionDigits: 2})
    } else {
      str += '0.00'
    }

    return str;
  })

</script>